<template>
  <nav v-if="visible" class="mobile-bottom-nav">
    <router-link
      to="/custom"
      class="mobile-bottom-nav-item"
      :class="{ 'is-active': activeMenu === '/custom' }"
    >
      <el-icon><Document /></el-icon>
      <span>学习任务</span>
    </router-link>
    <router-link
      to="/material"
      class="mobile-bottom-nav-item"
      :class="{ 'is-active': activeMenu === '/material' }"
    >
      <el-icon><Folder /></el-icon>
      <span>资料</span>
    </router-link>
    <router-link
      to="/course"
      class="mobile-bottom-nav-item"
      :class="{ 'is-active': activeMenu === '/course' }"
    >
      <el-icon><Reading /></el-icon>
      <span>公开课</span>
    </router-link>
    <router-link
      to="/profile"
      class="mobile-bottom-nav-item"
      :class="{ 'is-active': activeMenu === '/profile' }"
    >
      <el-icon><User /></el-icon>
      <span>个人中心</span>
    </router-link>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { Document, User, Reading, Folder } from '@element-plus/icons-vue'

const route = useRoute()

const activeMenu = computed(() => {
  if (route.path.startsWith('/profile')) return '/profile'
  if (route.path.startsWith('/material')) return '/material'
  if (route.path.startsWith('/course')) return '/course'
  if (route.path.startsWith('/play')) {
    if (route.query.from === 'course') return '/course'
    if (route.query.from === 'material') return '/material'
    return '/custom'
  }
  if (route.path.startsWith('/custom')) return '/custom'
  return '/custom'
})

const visible = computed(() => !route.path.startsWith('/play'))
</script>

<style scoped>
.mobile-bottom-nav {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  height: var(--member-bottom-nav-height);
  padding-bottom: env(safe-area-inset-bottom, 0);
  background: #fff;
  border-top: 1px solid #ebebeb;
  box-sizing: content-box;
}

.mobile-bottom-nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  color: #646a73;
  text-decoration: none;
  font-size: 11px;
  min-height: var(--member-bottom-nav-height);
}

.mobile-bottom-nav-item .el-icon {
  font-size: 20px;
}

.mobile-bottom-nav-item.is-active {
  color: var(--member-primary);
  font-weight: 500;
}

@media (max-width: 768px) {
  .mobile-bottom-nav {
    display: flex;
  }
}
</style>
